var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        bodyStyle: {
          padding: "30px 30px 30px 30px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
        },
        footer: null,
        maskClosable: false,
        "destroy-on-close": "",
      },
      scopedSlots: _vm._u([
        {
          key: "closeIcon",
          fn: function () {
            return undefined
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c("img", {
        attrs: {
          width: "390",
          height: "280",
          src: require("@/assets/auth_success.png"),
        },
      }),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("layout.guideLayout.bindSuccess"))),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("layout.guideLayout.waitText1")))]),
        _c("p", [_vm._v(_vm._s(_vm.$t("layout.guideLayout.waitText2")))]),
      ]),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleJump.apply(null, arguments)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("layout.guideLayout.linkJump")) + " ")]
          ),
          _c("a", { staticClass: "link", on: { click: _vm.handleBindMore } }, [
            _vm._v(
              " " + _vm._s(_vm.$t("layout.guideLayout.btnBindMore")) + " "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }